import React, { useState, useEffect } from "react";
import { Button } from "../../Components";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../contexts";
import { useSelector, useDispatch } from "react-redux";
import { updateRefundSettingsDetails } from "../../redux/slices";
import { updatePaymentSettings } from "../../redux/slices"
import {
  paymentSettingTypes,
  refundSettingsActionTypes,
} from "../../redux/utils";
import { useHardCode, useAPI } from "../../hooks";
import { Toast } from "..";
import "./bank.css";

export const Bank = () => {
  const [bankAcNo, setBankAcNo] = useState('');
  const [confirmBankAcNo, setConfirmBankAcNo] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [beneficiaryName, setBeneficiaryName] = useState('');
  const [upiID, setUpiID] = useState('');
  const [refundMode, setRefundMode] = useState("");
  const [showUPI, setShowUPI] = useState(true);
  const [showBank, setShowBank] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isError, setIsError] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const {
    isBtnDisabled,
    setIsBtnDisabled,
    isInternalServerError,
    setIsInternalServerError,
  } = useAppContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { GET_RETURN_PAYMENT_INFO } = useAPI();
  const storeConfigState = useSelector((state) => state.storeSettings);
  const productDetailsState = useSelector((state) => state.productDetails);
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  const selectedProductDetailsState = useSelector(
    (state) => state.selectedProductDetails
  );

  const onChangeAcNumber = (event) => {
    let accountNumber = event.target.value;
    accountNumber = accountNumber.replace(/\D/g, '');
    setBankAcNo(accountNumber);
  };

  const onChangeConfirmAcNumber = (event) => {
    let accountNumber = event.target.value;
    accountNumber = accountNumber.replace(/\D/g, '');
    setConfirmBankAcNo(accountNumber);
  }

  const UPI_FORM = (
    <div className="saara_upi_main">
      <div className="saara_upi_heading">
        {storeConfigState?.themeConfig?.enter_upi_id}
      </div>
      <div className="saara_upi_input_main">
        <input
          type="text"
          className="saara_upi_input"
          placeholder={storeConfigState?.themeConfig?.mobilenumber_upi}
          onChange={(e) => setUpiID(e.target.value)}
          required
        />
      </div>
    </div>
  );
  const BANK_FORM = (
    <div className="bank-account__form-data">
      <input
        value={bankAcNo}
        className="bank-account__form-inp form__bank-account"
        placeholder={storeConfigState?.themeConfig?.enter_bank_account_number}
        onChange={onChangeAcNumber}
        required
      />
      <input
        value={confirmBankAcNo}
        className="bank-account__form-inp form__rebank-account"
        placeholder={storeConfigState?.themeConfig?.reenter_bank_account_number}
        onChange={onChangeConfirmAcNumber}
        required
      />
      <input
        type="text"
        value={ifscCode}
        className="bank-account__form-inp form__IFSC"
        placeholder={storeConfigState?.themeConfig?.ifsc_code}
        onChange={(e) => setIfscCode(e.target.value.toUpperCase())}
        required
      />
      <input
        type="text"
        className="bank-account__form-inp form__beneficiary-name"
        value={beneficiaryName}
        placeholder={storeConfigState?.themeConfig?.enter_beneficiary_name}
        maxLength={255}
        onChange={(e) => setBeneficiaryName(e.target.value.toUpperCase())}
        required
      />
    </div>
  );

  useEffect(() => {
    if (
      productDetailsState.allowCustomerUpiDetails === true &&
      productDetailsState.allowCustomerBankDetails === true
    ) {
      setRefundMode("upi");
      setShowUPI(true);
      setShowBank(true);
    } else if (productDetailsState.allowCustomerUpiDetails === true) {
      setRefundMode("upi");
      setShowUPI(true);
      setShowBank(false);
    } else if (productDetailsState.allowCustomerBankDetails === true) {
      setRefundMode("bank");
      setShowBank(true);
      setShowUPI(false);
    }
  }, []);
  useEffect(() => {
    if (bankAcNo && confirmBankAcNo && ifscCode && beneficiaryName) {
      if (bankAcNo === confirmBankAcNo) {
        if (ifscCode.length === 11) {
          setIsBtnDisabled(false);
          setErrorMsg("");
          setIsError(false);
        }
        else {
          setIsBtnDisabled(true);
          setErrorMsg('Ivalid IFSC code');
          setIsError(true);
        }
      } else {
        setIsBtnDisabled(true);
        setErrorMsg(
          storeConfigState?.themeConfig?.account_number_mismatch_error
        );
        setIsError(true);
      }
    } else if (upiID) {
      const upiSplit = upiID.split("@");
      if (upiSplit[0] && upiSplit[1]) {
        setIsBtnDisabled(false);
      }
      else {
        setIsBtnDisabled(true);
      }
    } else {
      setIsBtnDisabled(true);
    }
  }, [bankAcNo, confirmBankAcNo, ifscCode, beneficiaryName, upiID]);

  const buttonHandler = async () => {
    const validateUPI = /^[\w.-]+@[\w.-]+$/.test(upiID);
    if (
      validateUPI ||
      (bankAcNo && confirmBankAcNo && ifscCode && beneficiaryName)
    ) {
      setIsError(false);
      setIsLoader(true);
      setIsBtnDisabled(true);
      dispatch(
        updatePaymentSettings({
          key: paymentSettingTypes.UPDATE_CUSTOMER_UPI_ID,
          value: upiID,
        })
      );
      dispatch(
        updatePaymentSettings({
          key: paymentSettingTypes.UPDATE_ACCOUNT_NUMBER,
          value: bankAcNo,
        })
      );
      dispatch(
        updatePaymentSettings({
          key: paymentSettingTypes.UPDATE_IFSC,
          value: ifscCode,
        })
      );
      dispatch(
        updatePaymentSettings({
          key: paymentSettingTypes.UPDATE_BENEFICIARY_NAME,
          value: beneficiaryName,
        })
      );

      (async () => {
        setIsLoader(true);
        setIsBtnDisabled(true);
        if (
          refundSettingsState.refundReviewRoute === "STORE_CREDIT" ||
          refundSettingsState.refundReviewRoute === "ORIGINAL_PAYMENT"
        ) {
          try {
            const VariantID = selectedProductDetailsState.variantID;
            const productID = selectedProductDetailsState.productID;
            const StoreUniqueID = storeConfigState.storeUniqueID;
            const OrderInfo = productDetailsState.orderInfo;
            const customerID = OrderInfo.customer_id;
            const response = await fetch(GET_RETURN_PAYMENT_INFO, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                test_mode: productDetailsState.testMode,
                store_name: StoreUniqueID,
                email: productDetailsState.customerEmail,
                order_number: productDetailsState.orderNumber,
                order_id: productDetailsState.recentOrderID,
                customer_id: customerID,
                variant_id: VariantID,
                product_id: productID,
                refund_to: refundSettingsState.refundOption,
                is_refund: true,
                image_list: exchangeSettingsState.imageList,
                reason_id: productDetailsState.returnReasonID,
                other_reason_desc: productDetailsState.reasonDetails,
                sub_reason_detail: productDetailsState.subReasonDetails,
                line_item_id: selectedProductDetailsState.lineItemID,
                quantity: parseInt(selectedProductDetailsState.selectedQuantity),
                access_code: otherSettingsState.accessCode,
                incentive: refundSettingsState.incentive,
                customer_data: productDetailsState.customerInfo,
              }),
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();

            if (response.ok) {
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_AMOUNT,
                  value: data?.payment_amount,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_GATEWAY_INFO,
                  value: data?.payment_gateway_info,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_LINK,
                  value: data?.payment_link,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_PAYMENT_REQUIRED,
                  value: false,
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_RAZORPAY_PAYMENT_ID,
                  value: "",
                })
              );
              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_COLLECT_PAYMENT_THROUGH,
                  value: data?.collect_payment_through,
                })
              );

              dispatch(
                updateRefundSettingsDetails({
                  key: refundSettingsActionTypes.UPDATE_RAZORPAY_DETAILS,
                  value: data,
                })
              );
              setIsLoader(false);
              setIsBtnDisabled(false);
              navigate("/ReturnReview");
            }
          } catch (error) {
            setIsInternalServerError(true);
          }
        }
      })();
    } else {
      setErrorMsg(storeConfigState?.themeConfig?.invalid_upi_bank_details);
      setIsError(true);
      setIsBtnDisabled(false);
    }
  };

  const clearInputs = () => {
    setBankAcNo("");
    setConfirmBankAcNo("");
    setIfscCode("");
    setBeneficiaryName("");
    setUpiID("");
    setIsError(false);
  };

  return (
    <div className="bank-account__page">
      {isInternalServerError && <Toast type="error" />}
      <div className="saara__container">
        <div className="bank-account__row">
          <div className="bank-account__form">
            <h1 className="bank-account__form-title">
              {storeConfigState?.themeConfig?.enter_bank_details}
            </h1>
            {isError && (
              <div className="saara-justify-content-center saara-error-msg">
                {errorMsg}
              </div>
            )}
            {successMsg !== "" && (
              <div className="saara-justify-content-center saara-success-msg">
                {successMsg}
              </div>
            )}
            <div className="saara_refund_mode_main">
              <div className="saara_refund_mode_title">
                {storeConfigState?.themeConfig?.refund_more}:
              </div>
              <div className="saara_refund_mode_options">
                {showUPI && (
                  <div className="saara_refund_mode_upi">
                    <input
                      type="radio"
                      id="upi_mode"
                      name="refund_mode"
                      value="upi"
                      checked={refundMode === "upi" ? true : false}
                      onChange={(e) => {
                        setRefundMode(e.target.value), clearInputs();
                      }}
                      className="saara_refund_mode_radio"
                    />
                     {" "}
                    <label
                      htmlFor="upi_mode"
                      className="saara_refund_mode_radio_label"
                    >
                      UPI ID
                    </label>
                  </div>
                )}
                {showBank && (
                  <div className="refund_mode_bank">
                    <input
                      type="radio"
                      id="bank_mode"
                      name="refund_mode"
                      value="bank"
                      checked={refundMode === "bank"}
                      onChange={(e) => {
                        setRefundMode(e.target.value), clearInputs();
                      }}
                      className="saara_refund_mode_radio"
                    />
                     {" "}
                    <label
                      htmlFor="bank_mode"
                      className="saara_refund_mode_radio_label"
                    >
                      Bank account
                    </label>
                  </div>
                )}
              </div>
            </div>
            <>{refundMode === "upi" ? UPI_FORM : BANK_FORM}</>
            <Button
              name={
                isLoader ? (
                  <div
                    className="saara-spinner-border saara-spinner-border-sm"
                    role="status"
                  >
                    <span className="saara-visually-hidden"></span>
                  </div>
                ) : (
                  storeConfigState?.themeConfig?.continue_button_label
                )
              }
              onClick={buttonHandler}
              disabled={isBtnDisabled}
            />
            <img
              src="assets/svg/big_logo.svg"
              className="bank-account__bg-logo bg-logo__left"
              alt=""
            />
            <img
              src="assets/svg/big_logo.svg"
              className="bank-account__bg-logo bg-logo__right"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};
